
let global_vars = {}

global_vars.TRANSFER_STATUSES = [
    {value: null, text: "ALL"},
    {value: 0, text: "PENDING"},
    {value: 1, text: "APPROVED"},
    {value: 2, text: "REJECTED"},
    {value: 3, text: "ADDED TO PULLIST"},
    {value: 4, text: "PULLED"},
    {value: 5, text: "PICKED"},
    {value: 6, text: "DROPPED"},
    {value: 7, text: "RECEIVED AT WAREHOUSE"},
    {value: 8, text: "READY TO SHIP"},
    {value: 9, text: "SHIPPED"},
    {value: 10, text: "DELIVERED"},
    {value: 11, text: "RECEIVED AT LOCATION"},
    {value: 12, text: "CONFIRMED"},
];

global_vars.TRANSFER_STATUSES_DICT = {
    null:  "ALL",
    0: "PENDING",
    1: "APPROVED",
    2: "REJECTED",
    3: "ADDED TO PULLIST",
    4: "PULLED",
    5: "PICKED",
    6: "DROPPED",
    7: "RECEIVED AT WAREHOUSE",
    8: "READY TO SHIP",
    9: "SHIPPED",
    10: "DELIVERED",
    11: "RECEIVED AT LOCATION",
    12:  "CONFIRMED",
};

global_vars.TRANSFER_STATUSES_REVERSE_DICT = {
    "ALL": null,
    "PENDING": 0,
    "APPROVED": 1,
    "REJECTED": 2,
    "ADDED TO PULLIST": 3,
    "PULLED": 4,
    "PICKED": 5,
    "DROPPED": 6,
    "RECEIVED AT WAREHOUSE": 7,
    "READY TO SHIP": 8,
    "SHIPPED": 9,
    "DELIVERED": 10,
    "RECEIVED AT LOCATION": 11,
    "CONFIRMED": 12,
};

global_vars.TRANSFER_STATUSES_COLORS_DICT = {
    null: "white",
    0: "blue",
    1: "green",
    2: "black",
    3: "salmon",
    4: "red",
    5: "#ffb7f5",
    6: "lightgreen",
    7: "brown",
    8: "pink",
    9: "cornflowerblue",
    10: "snow",
    11: "dodgerblue",
    12: "cream"
}

global_vars.allowed_states = [
    {value: "NY", text: "New York"},
    {value: "PA", text: "Pennsylvania"},
    {value: "NJ", text: "New Jersey"},
    {value: "VA", text: "Virginia"},
    {value: "DW", text: "DE"},
    {value: "MD", text: "MaryLand"}
]


export default global_vars;



// WEBPACK FOOTER //
// ./src/utilities/global_vars.js